<template>
  <div class="problem-info">
    <div class="banner">
      <img :src="require('@/assets/img/linli110/jubao.png')" alt="">
      <div class="text">一次举报，一份奖励； 守住安全，从你我开始</div>
    </div>
    <div class="form">
      <div class="title">消防安全举报</div>
      <van-form ref="vanForm">
        <div class="problem-detail">
          <van-cell required :border="false" class="top">消防隐患</van-cell>
          <van-field type="textarea" v-model="dataForm.query" placeholder="请输入" clearable autosize
                     :rules="[{ required: true, message: '请输入问题描述' }]"></van-field>
        </div>
        <van-popup v-model="communityShow" position="bottom">
          <van-cascader
              title="请选择"
              value="value"
              :field-names="{ text: 'label', value: 'value', children: 'children' }"
              :options="orgList"
              active-color="#1989fa"
              @close="communityShow = false"
              @finish="communityFinish"
          />
        </van-popup>
        <van-popup v-model="subareaShow" position="bottom">
          <van-picker title="请选择" show-toolbar :columns="subareaList" value-key="name" position="top"
                      @confirm="subareaConfirm" @cancel="subareaShow = false" />
        </van-popup>
<!--        <van-field v-if="orgId != 0 && orgList.length && !hasCommunity" name="社区" label="社区" placeholder="请选择" v-model="dataForm.communityName" @click="communityShow = true"-->
<!--                   required :rules="[{ required: true, message: '请选择社区' }]" clearable readonly is-link></van-field>-->
<!--        <van-field v-if="orgId != 0 && subareaList.length" name="小区" label="小区" placeholder="请选择" v-model="dataForm.subareaName" @click="subareaShow = true"-->
<!--                   clearable readonly is-link></van-field>-->
        <div class="problem-detail">
          <van-cell :border="false" class="top">
            <span>举报方式</span>
          </van-cell>
          <div class="anonymous-switch">
            <van-radio-group v-model="isAnonymous" direction="horizontal">
              <van-radio name="real">实名</van-radio>
              <van-radio name="anonymous">匿名</van-radio>
            </van-radio-group>
          </div>
          <div v-if="isAnonymous === 'anonymous'" class="anonymous-tip">
            选择匿名举报，后续事件处理将无法联系到您进行核对
          </div>
        </div>

        <template v-if="isAnonymous === 'real'">
          <van-field name="联系人" label="联系人" placeholder="请输入" v-model="dataForm.name"
                     required :rules="[{ required: true, message: '请输入联系人' }]" clearable></van-field>
          <van-field name="联系电话" label="联系电话" placeholder="请输入" v-model="dataForm.mobile"
                     required :rules="[
                       { required: true, message: '请输入联系电话' },
                       { pattern: /^[0-9]+$/, message: '联系电话只能输入数字' }
                     ]"
                     type="tel"
                     maxlength="20"
                     clearable></van-field>
        </template>
        <div class="problem-detail">
          <van-cell required :border="false" class="top">隐患地点</van-cell>
          <van-field type="textarea" v-model="dataForm.address" placeholder="请输入" clearable
                     show-word-limit :rules="[{ required: true, message: '请输入事发地址' }]"></van-field>
        </div>
        <van-row class="uploadBox">
          <van-col :span="24">
            <div class="upload" style="padding-left: 16px;">
              <upload-file
                  :file-list="fileList"
                  @filesUpload="filesUpload"
                  @delFile="delFile"
                  :upload-path="uploadPath"
                  :file-type="'imageOrVideo'"/>
            </div>
          </van-col>
        </van-row>
      </van-form>
    </div>
    <div class="button">
      <van-button class="submit-btn" @click="onSubmit">提交</van-button>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import UploadFile from "./uploadFile.vue";
export default {
  components: {UploadFile},
  data() {
    return {
      uuid: '',
      senderName: '',
      isGroup: '',
      groupName: '',
      isQyWx: '',
      orgId: '',
      hasCommunity: false,
      fromHome: 0,
      problemType: '',
      communityShow: false,
      subareaShow: false,
      orgList: [],
      subareaList: [],
      isAnonymous: 'real',
      dataForm: {
        location: '',
        community: '',
        communityName: '',
        subarea: '',
        subareaName: '',
        name: '',
        mobile: '',
        query: '',
        address: '',
        fileMessages: [],
        newFileMessages: [],
        deleteFiles: [],
      },
      fileList: [],
      uploadPath: 'files/problem/temporary'
    }
  },
  mounted() {
    this.uuid = this.$route.query.uuid
    this.senderName = this.$route.query.senderName
    this.isGroup = this.$route.query.isGroup
    this.groupName = this.$route.query.groupName
    this.isQyWx = this.$route.query.isQyWx
    this.orgId = this.$route.query.orgId
    this.fromHome = this.$route.query.fromHome
    if (this.$route.query.community) {
      this.dataForm.community = this.$route.query.community
      this.hasCommunity = true
    }
    if (this.$cookies.get('name') && this.$cookies.get('name') != 'null' && this.$cookies.get('name') != 'undefined') this.dataForm.name = this.$cookies.get('name')
    if (this.$cookies.get('mobile') && this.$cookies.get('mobile') != 'null' && this.$cookies.get('mobile') != 'undefined') this.dataForm.mobile = this.$cookies.get('mobile')
    if (this.$cookies.get('address') && this.$cookies.get('address') != 'null' && this.$cookies.get('address') != 'undefined') this.dataForm.address = this.$cookies.get('address')
    if (this.orgId != 13993) this.getLocation()
    this.getProblemTypeList()
    // this.getOrgId()
    // this.dataForm.address = '浙江省杭州市拱墅区上塘街道善贤人家'
    this.$httpAI({
      url: this.$httpAI.adornUrl('/commonApp/problemInfo/ai/getQuery'),
      method: 'GET',
      params: this.$httpAI.adornParams({
        uuid: this.uuid
      })
    }).then(({data}) => {
      if (data && data.code === 0) {
        this.dataForm.query = data.query
        if (this.$route.query.domain) {
          Vue.prototype.$httpAI.changeUrl(this.$route.query.domain, false)
        }
        this.getOrgList()
        if (this.isQyWx == 1) {
          this.$httpAI({
            url: this.$httpAI.adornUrl('/wxapp/wxai/aisenderinfo/getInfoBySenderName'),
            method: 'GET',
            params: this.$httpAI.adornParams({
              senderName: this.senderName,
              groupName: this.groupName
            })
          }).then(({data}) => {
            if (data && data.code === 0) {
              if (data.aiSenderInfo) {
                this.dataForm.name = data.aiSenderInfo.name
                this.dataForm.mobile = data.aiSenderInfo.mobile
                this.dataForm.address = data.aiSenderInfo.address
              }
            } else {
              this.$toast.fail(data.msg)
            }
          })
        }
      } else {
        this.$toast.fail(data.msg)
      }
    })
  },
  methods: {
    getProblemTypeList () {
      this.$httpAI({
        url: this.$httpAI.adornUrl('/sys/dict/listAllDictByCodeTypeNoLogin'),
        method: 'get',
        params: this.$httpAI.adornParams({
          code: 'problemType',
          type: 'xfyh'
        })
      }).then(({data}) => {
        if (data && data.code === 0) {
          this.problemType = data.list.length && data.list[0].id
        }
      })
    },
    getLocation () {
      const T = window.T;
      const geolocation = new T.Geolocation();

      geolocation.getCurrentPosition(e => {
        if (e.lnglat) {
          let geocoder = new T.Geocoder();
          // e.lnglat.lng = 120.15693
          // e.lnglat.lat = 30.31946
          geocoder.getLocation(e.lnglat, (result) => {
            if (result.result)
              this.dataForm.address = result.result.result['formatted_address']
            this.getOrgId()
          })
        }
      })
    },
    getOrgId () {
      this.$httpAI({
        url: this.$httpAI.adornUrl('/commonApp/problemInfo/ai/getSubareaCommunity'),
        method: 'post',
        params: this.$httpAI.adornParams({
          orgId: this.orgId,
          address: this.dataForm.address
        })
      }).then(({data}) => {
        if (data && data.code === 0) {
          if (data.orgMap.community) {
            this.dataForm.community = data.orgMap.community
            this.getSubareaList()
            if (this.orgList && this.orgList.length) {
              this.getOrgName(this.orgList)
            }
          }
          if (data.orgMap.subarea) {
            this.dataForm.subarea = data.orgMap.subarea
            if (this.subareaList && this.subareaList.length) {
              this.subareaList.map(i => {
                if (i.id == this.dataForm.subarea) this.dataForm.subareaName = i.name
              })
            }
          }
        }
      })
    },
    getOrgName (list) {
      list.map(i => {
        if (i.value == this.dataForm.community) {
          this.dataForm.communityName = i.label
        } else if (i.children && i.children.length > 0) {
          this.getList(i.children)
        }
      })
    },
    subareaConfirm (e) {
      this.dataForm.subarea = e.id
      this.dataForm.subareaName = e.name
      this.subareaShow = false
    },
    communityFinish (e) {
      let option = e.selectedOptions[e.selectedOptions.length - 1]
      this.dataForm.community = option.value
      this.dataForm.communityName = option.label
      this.communityShow = false
      this.getSubareaList()
    },
    getSubareaList () {
      this.$httpAI({
        url: this.$httpAI.adornUrl('/wxapp/sys/org/getChildren'),
        method: 'post',
        params: this.$httpAI.adornParams({
          parentId: this.dataForm.community
        })
      }).then(({data}) => {
        if (data && data.code === 0) {
          this.subareaList = data.children
          if (this.dataForm.subarea) {
            this.subareaList.map(i => {
              if (i.id == this.dataForm.subarea) this.dataForm.subareaName = i.name
            })
          }
        }
      })
    },
    getOrgList () {
      this.$httpAI({
        url: this.$httpAI.adornUrl('/wxapp/sys/org/getUserOrg'),
        method: 'post',
        params: this.$httpAI.adornParams({
          depth: 5
        })
      }).then(({data}) => {
        if (data && data.code === 0) {
          this.getList(data.userTreeOrg)
        }
      })
    },
    getList(list) {
      list.map(i => {
        if (i.value == (this.dataForm.community || this.orgId)) {
          if (i.children && i.children.length) {
            this.orgList = i.children
            if (this.dataForm.community) this.getOrgName(this.orgList)
          } else if (i.depth == 5) {
            this.dataForm.community = i.value
            this.getSubareaList()
          }
        } else if (i.children && i.children.length > 0) {
          this.getList(i.children)
        }
      })
    },
    getUUID () {
      return new Promise((resolve) => {
        this.$httpAI({
          url: this.$httpAI.adornUrl('/commonApp/problemInfo/ai/querySave'),
          method: 'POST',
          data: this.$httpAI.adornData({
            uuid: this.uuid,
            query: this.dataForm.query,
            senderName: this.senderName,
            isGroup: this.isGroup,
            groupName: this.groupName,
            isQyWx: this.isQyWx,
            orgId: this.orgId
          })
        }).then(({data}) => {
          if (data && data.code === 0) {
            resolve(data.uuid)
          }
        })
      })
    },
    filesUpload (files) {
      this.dataForm.newFileMessages = files
      this.dataForm.fileMessages = files
    },
    delFile (id) {
      this.dataForm.deleteFiles.push(id)
    },
    onSubmit() {
      this.$refs.vanForm.validate().then(async res => {
        this.$toast.loading({duration: 0, message: '提交中...', forbidClick: true,});
        if (this.fromHome == 1) {
          await this.getUUID().then(e => {
            this.uuid = e
          })
        }
        this.$httpAI({
          url: this.$httpAI.adornUrl('/commonApp/problemInfo/ai/save'),
          method: 'POST',
          data: this.$httpAI.adornData({
            uuid: this.uuid,
            query: this.dataForm.query,
            name: this.dataForm.name,
            mobile: this.dataForm.mobile,
            address: this.dataForm.address,
            senderName: this.senderName,
            isGroup: this.isGroup,
            groupName: this.groupName,
            community: this.dataForm.community,
            subarea: this.dataForm.subarea,
            isQyWx: this.isQyWx,
            problemType: this.problemType,
            solveStatus: 10,
            street: this.orgId,
            newFileMessages: this.dataForm.newFileMessages
          })
        }).then(({data}) => {
          this.$toast.clear()
          if (data && data.code === 0) {
            if (this.isAnonymous === 'real') {
              this.$cookies.set('name', this.dataForm.name)
              this.$cookies.set('mobile', this.dataForm.mobile)
            }
            this.$cookies.set('address', this.dataForm.address)
            this.$router.replace('/problemFinished')
          } else {
            this.$toast.fail(data.msg)
          }
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .van-cell__value--alone {
  color: #666;
}

.disable {
  pointer-events: none;
}

.problem-info {
  font-family: PingFangSC-Regular;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.title {
  height: 96px;
  background: #FFFFFF;
  font-size: 32px;
  font-family: 'PingFangSC-Semibold';
  font-weight: 600;
  color: #333333;
  line-height: 96px;
  padding: 0 30px;
}

.problem-item {
  // height: 164px;
  background: #FFFFFF;
  border-radius: 20px 20px 0px 0px;
  // padding: 0 30px;
  .top {
    height: 88px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 30px;

    .top-left {
      font-size: 34px;
      font-family: 'PingFangSC-Regular';
      font-weight: 400;
      color: #666666;

      span {
        color: #E9564B;
      }
    }

    .top-right {
      width: 28px;
      height: 28px;
    }
  }

  .down {
    // height: 76px;
    font-size: 34px;
    font-family: 'PingFangSC-Medium';
    font-weight: 500;
    color: #333333;
  }

  ::v-deep .van-cell {
    padding: 0 30px;
  }

  ::v-deep .isEmpty textarea {
    height: 50px !important;
  }
}

.problem-detail {
  // height: 254px;
  background: #FFFFFF;
  padding-top: 24px;

  .top {
    font-size: 30px;
    font-family: 'PingFangSC-Regular';
    font-weight: 400;
    color: #666666;
    padding: 0 30px;
    margin-bottom: 12px;
  }

  .des {
    height: 96px;
    font-size: 34px;
    font-family: 'PingFangSC-Regular';
    font-weight: 400;
    color: #333333;
  }

  ::v-deep .van-field__word-limit {
    color: #999999;
  }

  ::v-deep .van-cell {
    padding: 0 30px;
  }
}

.upload-picture {
  // min-height: 270px;
  background-color: #FFFFFF;
  padding: 0 30px 20px;

  ::v-deep .van-cell {
    padding-top: 0;
    padding-left: 0;
  }

  .top {
    height: 88px;
    border-radius: 20px 20px 0px 0px;
    font-size: 26px;
    font-family: 'PingFangSC-Regular';
    font-weight: 400;
    color: #666666;
    line-height: 88px;
  }

  ::v-deep .uploadBox {
    margin: 0;
  }

  ::v-deep .van-uploader__upload {
    background-color: #F5F5F5;
    border-radius: 16px;
  }
}

.button {
  position: fixed;
  bottom: 0;
  width: 100%;
  padding: 0 30px;
  height: 88px;
  margin-bottom: 40px;

  .submit-btn {
    width: 100%;
    height: 88px;
    background: #4581F8;
    border-radius: 8px;
    font-size: 32px;
    font-family: 'PingFangSC-Medium';
    font-weight: 500;
    color: #FFFFFF;
    line-height: 32px;
  }
}

::v-deep .van-field__label {
  display: flex;
  align-items: center;
}

.btnSendText {
  color: #1989fa;
  margin-right: 40px;
}
.anonymous-switch {
  padding: 20px 30px;

  ::v-deep .van-radio-group {
    display: flex;
    justify-content: flex-start;
    gap: 40px;
  }

  ::v-deep .van-radio__label {
    font-size: 30px;
    color: #333333;
  }
}
.anonymous-tip {
  padding: 10px 30px;
  font-size: 26px;
  color: #ff6b00;
  line-height: 36px;
  background-color: #fff7f0;
  margin: 10px 0;
  border-left: 3px solid #ff6b00;
}
.banner {
  position: relative;
  .text {
    width: 100%;
    text-align: center;
    padding: 8px 0;
    line-height: 34px;
    font-family: "PingFang Bold";
    z-index: 999;
    font-size: 24px;
    color: #B53D2B;
    position: absolute;
    bottom: 0;
    background: rgba(255,255,255,0.5);
  }
  img {
    width: 750px;
    height: 500px;
  }
}
.form {
  margin-bottom: 180px;
  background-color: #fff;
}
</style>
